/*
 * returns the value at the last index in 'array'
 *
 * arrayLast([ 'foo', 'bar', baz' ]) -> 'baz'
 */
module.exports = function arrayLast (array) {
  return array[array.length - 1]
}
